// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Bold = function Bold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.813 2.188c0-.52.417-.938.937-.938h7.344a4.843 4.843 0 0 1 3.387 8.309 4.844 4.844 0 0 1-2.137 9.191H3.75a.935.935 0 0 1-.937-.937c0-.52.417-.938.937-.938h.938V3.125H3.75a.935.935 0 0 1-.937-.937m8.28 6.874a2.967 2.967 0 0 0 2.97-2.968 2.967 2.967 0 0 0-2.97-2.969h-4.53v5.938zm-4.53 1.876v5.937h5.78a2.967 2.967 0 0 0 2.97-2.969 2.967 2.967 0 0 0-2.97-2.969h-5.78"
  }));
};
